import { Ifo } from './types'

const ifos: Ifo[] = [
  // {
  //   id: 'mtv',
  //   address: '0x0Ac5f5011535fD5EbecA9cf9885a5e4115fe8c0B',
  //   isActive: true,
  //   name: 'MetaVill DAO',
  //   subTitle: 'All In One Service on BSC Network DeFi + Metaverse + NFT + GAME-Fi',
  //   description:'MetaVill DAO is the yield farm DeFi 2.0 on Binance Smart Chain',
  //   launchDate: 'April 26th',
  //   launchTime: '9AM UTC',
  //   saleAmount: '14 000 MTV',
  //   raiseAmount: '$182,00.00',
  //   cakeToBurn: '$0',
  //   projectSiteUrl: 'https://defi.metvill.life',
  //   currency: 'BUSD',
  //   currencyAddress: '0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56',
  //   tokenDecimals: 18,
  //   releaseBlockNumber: 17278000,
  //   isWhiteList:true,
  // },
  // {
  //   id: 'mtv',
  //   address: '0x1d4E797e3e182356Be26C1193856526e064bb8f0',
  //   isActive: true,
  //   name: 'MetaVill DAO',
  //   subTitle: 'All In One Service on BSC Network',
  //   description:'MetaVill DAO is the yield farm DeFi 2.0 on Binance Smart Chain',
  //   launchDate: 'April 26th',
  //   launchTime: '9AM UTC',
  //   saleAmount: '6 000 MTV',
  //   raiseAmount: '$90,000.00',
  //   cakeToBurn: '$0',
  //   projectSiteUrl: 'https://defi.metvill.life',
  //   currency: 'BUSD',
  //   currencyAddress: '0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56',
  //   tokenDecimals: 18,
  //   releaseBlockNumber: 17278000,
  // },
  // {
  //   id: 'ditto',
  //   address: '0x570c9eB19553526Fb35895a531928E19C7D20788',
  //   isActive: false,
  //   name: 'Ditto (DITTO)',
  //   subTitle: 'Next-gen elastic supply token',
  //   description:
  //     'Ditto is the first elastic supply token on the Binance Smart Chain. Its goal is to maintain a stable price of $1, where its supply will adapt to changes in demand. All supply changes will apply equally to every wallet holding Ditto, and holders should always have the same % of the total supply',
  //   launchDate: 'Dec. 23',
  //   launchTime: '3PM SGT',
  //   saleAmount: '700,000 DITTO',
  //   raiseAmount: '$630,000',
  //   cakeToBurn: '$315,000',
  //   projectSiteUrl: 'https://ditto.money/',
  //   currency: 'CAKE-BNB LP',
  //   currencyAddress: '0xA527a61703D82139F8a06Bc30097cC9CAA2df5A6',
  //   tokenDecimals: 9,
  //   releaseBlockNumber: 3279767,
  // },
  // {
  //   id: 'tenet',
  //   address: '0xB922aA19A2603A07C6C9ED6c236618C9bac51f06',
  //   isActive: false,
  //   name: 'Tenet (TEN)',
  //   subTitle: 'Cross-chain Automated Market Maker',
  //   description:
  //     'Tenet is a cross-chain Automated Market Maker (AMM) connector that provides a decentralized Liquidity Tap for various tokens. The Liquidity Tap is the powerhouse of the Liquidity Pool, employing a dynamic algorithm to give the Liquidity Provider fairer, more efficient, and richer incentives. Tenet aims to build a cross-chain and cross-platform toolkit protocol that allows the demand side to customize the parameters of the liquidity tap, allowing them to reach out to more liquidity participants effectively and with relative ease.',
  //   launchDate: 'Jan. 5',
  //   launchTime: '3PM SGT',
  //   saleAmount: '1,000,000 TEN',
  //   raiseAmount: '$1,000,000',
  //   cakeToBurn: '$500,000',
  //   projectSiteUrl: 'https://www.tenet.farm/',
  //   currency: 'CAKE-BNB LP',
  //   currencyAddress: '0xA527a61703D82139F8a06Bc30097cC9CAA2df5A6',
  //   tokenDecimals: 18,
  //   releaseBlockNumber: 3483883,
  // },
  // {
  //   id: 'helmet',
  //   address: '0xa32509d760ee47Eb2Be96D338b5d69B5FBa4eFEB',
  //   isActive: false,
  //   name: 'Helmet.insure (Helmet)',
  //   subTitle: 'Crypto-assets insurance trading platform',
  //   description:
  //     'Helmet is a peer-to-peer insurance protocol written with options trading logic, which allows anyone to create any insurance policy easily in the market. Helmet aims to enable DeFi users to be protected against the risk of price fluctuations by providing price-shield insurance for BSC assets. They provide suppliers with a range of insurance types to sell, giving a variety of hedging strategies to the market.',
  //   launchDate: 'Jan. 13',
  //   launchTime: '5PM SGT',
  //   saleAmount: '10,000,000 Helmet',
  //   raiseAmount: '$1,000,000',
  //   cakeToBurn: '$500,000',
  //   projectSiteUrl: 'https://www.helmet.insure/',
  //   currency: 'CAKE-BNB LP',
  //   currencyAddress: '0xA527a61703D82139F8a06Bc30097cC9CAA2df5A6',
  //   tokenDecimals: 18,
  //   releaseBlockNumber: 3771926,
  // },
  // {
  //   id: 'soteria',
  //   address: '0x9C21123D94b93361a29B2C2EFB3d5CD8B17e0A9e',
  //   isActive: true,
  //   name: 'Soteria',
  //   subTitle: 'A blockchain based mutual to share the risk of DeFi on Binance Smart Chain',
  //   description:
  //     'Soteria allows users to buy insurance cover to greatly diminish or reduce the financial risk of hacks. It replaces the idea of a traditional insurance company, because it is wholly owned by the members. The model encourages engagement as members receive economic incentives for participating in Risk Assessment, Claims Assessment and Governance.',
  //   launchDate: 'Jan. 21',
  //   launchTime: '4PM SGT',
  //   saleAmount: '1,500,000 wSOTE',
  //   raiseAmount: '$525,000',
  //   cakeToBurn: '$262,500',
  //   projectSiteUrl: 'https://soteria.finance/#/',
  //   currency: 'CAKE-BNB LP',
  //   currencyAddress: '0xA527a61703D82139F8a06Bc30097cC9CAA2df5A6',
  //   tokenDecimals: 18,
  //   releaseBlockNumber: 4086064,
  // },
]

export default ifos
